import { useState, useEffect } from "react"
import { Cookie, load } from "@kiwicom/cookies"
import { useSelector } from "react-redux"
import { bidSelector } from "../../../services/booking/booking"
import { useGetIsLoggedIn } from "@kiwicom/nitro/lib/services/auth/context"

type UseIntroLoginModal = {
  isIntroModalVisible: boolean
  onCloseIntroModal: () => void
}

/**
 * Intro login modal is displayed for not logged users who also do not have the simple token stored
 *
 * Tracking event of "continue with email" is
 * already implemented in Nitro's MagicLogin.
 *
 * @returns
 * - isIntroModalVisible (value based on user being logged out and not having simple token)
 * - onCloseIntroModal (required because Nitro doesn't close the modal automatically).
 */
const useIntroLoginModal = (): UseIntroLoginModal => {
  const [isIntroModalVisible, setIsIntroModalVisible] = useState<boolean>(false)
  const isLoggedIn = useGetIsLoggedIn()
  const bid = useSelector(bidSelector)
  const simpleTokenCookie = JSON.parse(load(Cookie.SIMPLE_TOKEN) ?? "{}")
  const simpleToken = simpleTokenCookie.bid === bid ? simpleTokenCookie.token : null

  useEffect(() => {
    void isLoggedIn().then((loggedIn) => {
      const shouldDisplayIntroLogin = !loggedIn && !simpleToken
      if (shouldDisplayIntroLogin) {
        setIsIntroModalVisible(true)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simpleToken])

  const onCloseIntroModal = () => setIsIntroModalVisible(false)

  return { isIntroModalVisible, onCloseIntroModal }
}

export default useIntroLoginModal
